import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import GitlabSecurityCredentialsForm from "./GitlabSecurityCredentialsForm";
import GitlabSecurityConfigListing from "./GitlabConfigListing";

export default function GitlabSecurityPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={GitlabSecurityCredentialsForm}
      PullConfigListingView={GitlabSecurityConfigListing}
    />
  );
}
